module.exports = "<div class=\"item options-input\">\r\n  {{formOption.label}}\r\n  <label class=\"item item-input\">\r\n    <input type=\"number\" placeholder=\"\" class=\"text-input\" ng-model=\"formOption.model[formOption.option]\">\r\n  </label>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/js/forms/directives/options/number.html
// module id = 3417
// module chunks = 0